import { Component, OnInit } from '@angular/core';
import { ModalDirective, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-event4',
  templateUrl: './event4.component.html',
  styleUrls: ['./event4.component.scss']
})
export class Event4Component implements OnInit {

  constructor(private modalRef: BsModalRef) { } 

  ngOnInit(): void {
  }

  public onCancel(): void {
    this.modalRef.hide();
  }

}
